import { render, staticRenderFns } from "./InputSubSelect.vue?vue&type=template&id=28f42600&"
import script from "./InputSubSelect.vue?vue&type=script&lang=ts&"
export * from "./InputSubSelect.vue?vue&type=script&lang=ts&"
import style0 from "./InputSubSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports